<template>
  <section class="section section__content --centered">
    <HeadingBlock :content="content" />
    <ul class="detailed-card__group">
      <DetailedCard
        :content="card"
        v-for="(card, cardIndex) in content.cards"
        :key="card.flexKey"
        v-reveal="{ delay: 50 * cardIndex + 250 }"
      />
    </ul>
  </section>
</template>

<script>
import { HeadingBlock } from '@/components/blocks'
import { DetailedCard } from '@/components/cards'
import { DefaultSectionProps } from '@/mixins'

export default {
  name: 'DetailedCardsSection',
  mixins: [DefaultSectionProps],
  components: { DetailedCard, HeadingBlock },
}
</script>
